import ReactDOM from "react-dom";
import { ShareModal } from "./share-modal";
import React from "react";

let shareModalDiv;

export const unmount = () => {
  if (!shareModalDiv) {
    return;
  }
  ReactDOM.unmountComponentAtNode(shareModalDiv);
};

export default () => {
  shareModalDiv = document.querySelector("#share-modal-app");
  if (!shareModalDiv) {
    return;
  }

  let modalRootElement = document.getElementById('share-modal-container')
  if(!modalRootElement) {
    modalRootElement = document.createElement("div");
    modalRootElement.id = "share-modal-container";
    document.body.appendChild(modalRootElement);
  }

  return ReactDOM.render(
    <ShareModal
      skuTitle={shareModalDiv.getAttribute("data-sku-name")}
      canonicalUrl={shareModalDiv.getAttribute("data-share-url")}
      defaultImage={shareModalDiv.getAttribute("data-share-image-url")}
      rootElement={modalRootElement}
    />,
    shareModalDiv
  );
}
